import { httpClient } from "@/lib/http-client/http-client";
import { IActivity, IInbox } from "../interface/responses/IInboxResponses";
import { API_ROUTES } from "@/shared/constants/api.routes";
import { IBaseListResponse } from "../interface/responses/IBaseResponse";
import { IGetInboxRequest } from "../interface/requests/IInboxRequest";

class InboxService {
  async getInbox(request: IGetInboxRequest) {
    const params = new URLSearchParams();
    
    if (request.isRead !== undefined) {
      params.set("isRead", request.isRead.toString());
    }
    if (request.isGrouped !== undefined) {
      params.set("isGrouped", request.isGrouped.toString());
    }
    if (request.targetId !== undefined) {
      params.set("targetId", request.targetId);
    }
    return (await httpClient.get(
      API_ROUTES.Inbox.getInbox(request.userId) + "?" + params.toString()
    )) as IBaseListResponse<IInbox[]>;
  }
  async markAsRead(inboxId: string) {
    return (await httpClient.patch<IInbox>(
      API_ROUTES.Inbox.markAsRead(inboxId)
    )) ;
  }
  async getActivities(specificationId: string, query: string = "") {
    return (await httpClient.get(
      API_ROUTES.Inbox.activities(specificationId) + query
    )) as IBaseListResponse<IActivity[]>;
  }
  async toggleFavorite(inboxId: string) {
    return (await httpClient.patch<IInbox>(
      API_ROUTES.Inbox.toggleFavorite(inboxId)
    ));
  }
  async delete(inboxId: string) {
    return (await httpClient.delete<IInbox>(
      API_ROUTES.Inbox.delete(inboxId)
    ));
  }
}

export const inboxService = new InboxService();
